import { bulkShareLookupToMyFeed } from 'redux/subscriptions/actions';

import constants from '../constants';

export function bulkShareToMyFeed(payload) {
  return dispatch => dispatch(bulkShareLookupToMyFeed(payload, constants));
}
